import { render, staticRenderFns } from "./RequestForMaterialsEdit.vue?vue&type=template&id=512fa618&"
import script from "./RequestForMaterialsEdit.vue?vue&type=script&lang=js&"
export * from "./RequestForMaterialsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports